<template>
    <div id="app">
        <AnonBar v-show="anonBarVisible" @show="showAnonBar"  @hide="hideAnonBar"></AnonBar>
        <ShareBar v-show="partnerBarVisible" @show="showPartnerBar"  @hide="hidePartnerBar"></ShareBar>
        <div id="bar-space" v-if="anyBarVisible"></div>
        <div id="content"><router-view /></div>
        <md-bottom-bar md-sync-route v-if="!isAuthenticated">
            <md-bottom-bar-item
                to="/"
                exact
                md-label="Home"
                md-icon="home"
            ></md-bottom-bar-item>
            <md-bottom-bar-item
                to="/login"
                md-label="Login"
                md-icon="vpn_key"
            ></md-bottom-bar-item>
        </md-bottom-bar>
        <md-bottom-bar md-sync-route md-type="shift" v-if="isAuthenticated">
            <md-bottom-bar-item
                to="/rate"
                exact
                md-label="You"
                md-icon="thumbs_up_down"
            ></md-bottom-bar-item>
            <md-bottom-bar-item
                to="/matches"
                md-label="Together"
                md-icon="whatshot"
            ></md-bottom-bar-item>
            <md-bottom-bar-item
                to="/chat"
                md-label="Chat"
                md-icon="chat"
                @click.native="subscribeNotifications"
            ></md-bottom-bar-item>
        </md-bottom-bar>
    </div>
</template>
<script>
import api from '@/services/api'
import Registration from '@/registerServiceWorker'
import AnonBar from '@/components/AnonBar.vue'
import ShareBar from '@/components/ShareBar.vue'

export default {
    data() {
        return {
            isAuthenticated: false,
            anonBarVisible: true,
            partnerBarVisible: true,
        }
    },
    components: {
        AnonBar,
        ShareBar,
    },
    computed: {
        anyBarVisible() {
            return this.anonBarVisible || this.partnerBarVisible;
        }
    },
    created() {
        api.authenticated.subscribe(isAuthenticated => {
            this.isAuthenticated = isAuthenticated
        })
    },
    methods: {
        async subscribeNotifications() {
            const registration = await Registration;
            console.log('registration', registration);
            let subscription = await registration.pushManager.getSubscription();
            console.log('subscription', subscription);
            if (!subscription) {
                subscription = await registration.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: 'BAx3BTVvNfTKUXvL3s9mV9pTmaYwMU3xUMMMm_mB0aOUcWehvGlnpX_A4-DMvsgzspwYt1jO8u2oXus-QQQ6f30'
                });
                api.service('users').patch('me', {
                    subscription: JSON.parse(JSON.stringify(subscription))
                });
                console.log('subscription', JSON.stringify(subscription));
            }
        },
        hideAnonBar() {
            this.anonBarVisible = false;
        },
        showAnonBar() {
            this.anonBarVisible = true;
        },
        hidePartnerBar() {
            this.partnerBarVisible = false;
        },
        showPartnerBar() {
            this.partnerBarVisible = true;
        },
    },
}
</script>
<style lang="less" scoped>
#bar-space {
    height: 56px;
}
#app {
    display: grid;
    height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
}
#content {
    flex: 1;
    overflow: auto;
    display: flex;
    justify-content: stretch;
    align-items: stretch;
}
</style>
<style lang="less">
#body .md-bottom-bar {
    // background-color: #212121;
    // background-color: white;
    // color: black;
    // --md-theme-default-text-primary-on-primary: rgba(0,0,0,.9);
    // --md-theme-default-icon-on-primary: #6D98FF;
}
.md-bottom-bar > .md-ripple {
    justify-content: center;
}
#content > * {
    flex: 1;
}
</style>
